import FixedHeaderRenderer from './fixed-header';
import VirtualizationRenderer from './virtualization';

module.exports = {
  FixedHeader: FixedHeaderRenderer,
  Virtualization: VirtualizationRenderer,
};




// WEBPACK FOOTER //
// ./js/layout/renderer/index.js